import MAINSTATE from "../../State"
import {Notification} from "@nebularstreams/libmui";
import CONFIG from "../../../config/Config";

const
	UPLOAD_PHASE_PERCENT = 50;

function uploadFileWithProgress(url, formData, onProgress) {

	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		let fakeInterval;
		let realProgress;

		xhr.open("POST", url, true);
		xhr.setRequestHeader("nanotoken", MAINSTATE.token);
		xhr.upload.onprogress = (event) => {
			if (event.lengthComputable) {
				const percent = Math.round((event.loaded / event.total) * UPLOAD_PHASE_PERCENT); // Max 50% for upload phase
				if (percent) {
					console.log("progress", percent);
					realProgress = percent;
					onProgress(percent);
				}
			}
		};

		xhr.onload = () => {
			if (xhr.status === 200) {
				clearInterval(fakeInterval); // Stop fake progress
				onProgress(100); // Instant jump to 100%
				resolve(JSON.parse(xhr.responseText));
			} else {
				let message = "";
				try {
					const errorDetail = JSON.parse(xhr.responseText);
					message = errorDetail?.message;
				} catch (e) {
				}
				clearInterval(fakeInterval);
				reject(new Error("Upload failed" + (message ? ": " + message : "")));
			}
		};

		xhr.onerror = () => {
			clearInterval(fakeInterval);
			reject(new Error("Network error"));
		};


		// Fake processing phase (from UPLOAD_PHASE_PERCENT to 100%)
		fakeInterval = setInterval(() => {

			if (realProgress >= UPLOAD_PHASE_PERCENT) {
				if (realProgress < 100) {
					realProgress += Math.random(); // Smooth random increments
					realProgress = Math.min(realProgress, 100); // Clamp to 100%
				} else realProgress = 90;
			}

			onProgress(realProgress);
		}, 250);

		xhr.send(formData);

	});
};

async function uploadFile(STATE, file, options = {}) {

	if (!STATE) throw new Error("unknown service");

	const {service} = STATE;
	const streamname = STATE.perorga && !STATE.streamname ? MAINSTATE.organization + "-xxxxx" : STATE.streamname;
	if (!streamname) throw new Error("You need to setup the streamname");
	if (!file) throw new Error("No file selected.");

	const formData = new FormData();
	formData.append("file", file);

	STATE.uploading = true;

	const
		placeholder = {
			file: file.name,
			id: Date.now().toString(30)
		},
		{uploadingFiles} = STATE;

	uploadingFiles.push(placeholder);

	options.refresh && options.refresh();

	const
		index = uploadingFiles.indexOf(placeholder);

	try {

		const
			result = await uploadFileWithProgress(`${CONFIG.apiserver}/upload/${service}/${streamname}`, formData, (percentage) => {
				const item = document.getElementById(placeholder.id)?.childNodes[0];
				item && (item.style.width = percentage + "%");
				placeholder.progress = percentage;
			});

		if (result.success) {

			STATE.uploading = false;

			if (options.onUpload) options.onUpload();
		}

		delete STATE.error;

	} catch (e) {
		STATE.error = e.message;
	} finally {
		STATE.uploading = false;
		if (index >= 0) uploadingFiles.splice(index, 1);
		options.refresh && options.refresh();
	}
}

function initUpload(state, dropzone, options = {}) {

	const {type = "mp4"} = options;

	dropzone.addEventListener("dragover", (e) => {
		if (e.dataTransfer.items?.length && e.dataTransfer.items[0].kind === "file") {
			e.preventDefault();
			dropzone.classList.add("dragging");
		}
	});

	dropzone.addEventListener("dragleave", (e) => {
		// if (!e.dataTransfer.files?.length) return;
		dropzone.classList.remove("dragging");
	});

	dropzone.addEventListener("drop", (e) => {

		if (!e.dataTransfer.files?.length) return;

		e.preventDefault();
		dropzone.classList.remove("dragging");
		const promises = [];

		for (const file of e.dataTransfer.files) {

			if (!file || !file.name.toLowerCase().endsWith(`.${type}`)) {
				Notification.add(`${file.name}: Only ${type.toUpperCase()} files allowed`);
			} else {
				promises.push(
					uploadFile(state, file, options)
						.catch((e) => Notification.add(e.message))
				)
			}
		}

		promises.length && Promise.allSettled(promises)
			.then(() => {
			})
			.catch((e) => Notification.add(e.message))

	});

	document.body.addEventListener("drop", (e) => {
		e.preventDefault();
	});

}

export {initUpload, uploadFile};
